import graphql__600f68b4ff3e7d7c03aa from "./__generated__/PageSectionAnalyticsDataList_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import AnalyticsDatumCardRow from "../AnalyticsDatum/AnalyticsDatumCardRow";

const PageSectionAnalyticsDataList = props => {
  const { title, description, analyticsData } = props.pageSection;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName="icon-activity"
    >
      <div className="analytics-data-list">
        {analyticsData.map(analyticsDatum => (
          <AnalyticsDatumCardRow
            key={analyticsDatum.id}
            analyticsDatum={analyticsDatum}
          />
        ))}
      </div>
    </PageSectionBlockWithTitleAndDescription>
  );
};

export default createFragmentContainer(PageSectionAnalyticsDataList, {
  pageSection: graphql__600f68b4ff3e7d7c03aa
});
